import { UserRepository } from "../../repositories/userRepository"
import { UseCase } from "../useCase"

export type SendUserNotificationRequest = {
	userEmail: string
	subject: string
	messageHtml: string
	attachmentFile?: File
}

export class SendUserNotificationUseCase
	implements
		UseCase<
			SendUserNotificationRequest,
			{ success: boolean; notificationCreated: boolean; emailSent: boolean; errors: string[] }
		>
{
	private _repository: UserRepository

	constructor({ UserRepository }: { UserRepository: UserRepository }) {
		this._repository = UserRepository
	}

	exec(
		payload: SendUserNotificationRequest
	): Promise<{ success: boolean; notificationCreated: boolean; emailSent: boolean; errors: string[] }> {
		return this._repository.sendUserNotification(payload)
	}
}
